import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'

import TextInput, { TextInputProps } from '../TextInput'

const PhoneNumberFormatCustom = dynamic(
  () => import('./PhoneNumberFormatCustom'),
  {
    ssr: false,
    loading: () => (
      <TextInput placeholder="07400 123456" sx={{ width: '100%' }} />
    )
  }
)

export interface PhoneNumberInputProps extends TextInputProps {}

const TextInputNumber: RFC<PhoneNumberInputProps> = ({
  onChange,
  ...props
}) => {
  const [isLoaded, setLoaded] = useState<boolean>(false)

  useEffect(() => {
    if (isLoaded) return

    setTimeout(() => setLoaded(true), 200)
  }, [])

  return (
    <TextInput
      {...props}
      sx={{
        '.PhoneInputInput': {
          border: 'none',
          fontFamily: 'Poppins',
          fontSize: 15,
          outline: 'none',
          color: 'primary.dark',
          fontWeight: 300
        },
        '.PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border': {
          boxShadow: '0 0 0 #000'
        },
        '.PhoneInputCountrySelect:focus + .PhoneInputCountryIcon + .PhoneInputCountrySelectArrow':
          {
            color: 'primary.dark'
          },
        ...(!isLoaded && { '.PhoneInputCountry': { display: 'none' } }),
        ...props?.sx
      }}
      onChange={onChange}
      InputLabelProps={{ shrink: true }}
      InputProps={{
        inputComponent: PhoneNumberFormatCustom as any,
        ...props.InputProps
      }}
    />
  )
}

export default TextInputNumber
